import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiOfferApproveRequest,
  ApiOfferConfirmationCommentUpdate,
  ApiOfferConfig,
  ApiOfferFileTypes,
  ApiOfferPublic,
  ApiOfferRequest,
  ApiOfferSavePayload,
  ApiOffersFilter,
  ApiPagedOfferData,
} from "@/types/recruit/offer.types.ts";

export const apiOffers = {
  create: async function (payload: ApiOfferSavePayload) {
    return api.post<ApiOfferRequest>("/api/v1/offers", payload);
  },
  update: async function (id: number, payload: ApiOfferSavePayload) {
    return api.put<ApiOfferRequest>(`/api/v1/offers/${id}`, payload);
  },
  search: (filter: ApiOffersFilter, signal?: AbortSignal) => {
    return api.post<ApiPagedOfferData>("/api/v1/offers/search", filter, signal);
  },
  delete: async function (id: number) {
    return api.delete(`/api/v1/offers/${id}`);
  },
  getById: async function (id: number) {
    return api.get<ApiOfferRequest>(`/api/v1/offers/${id}`);
  },
  cancelRequest: (id: number) => {
    return api.post<ApiOfferRequest>(`/api/v1/offers/${id}/cancel`, {});
  },
  approveRequest: (id: number, payload: ApiOfferApproveRequest) => {
    return api.post<ApiOfferRequest>(`/api/v1/offers/${id}/approve`, payload);
  },
  rejectRequest: (id: number, payload: ApiOfferApproveRequest) => {
    return api.post<ApiOfferRequest>(`/api/v1/offers/${id}/reject`, payload);
  },
  updateConfirmationComment: (id: number, body: ApiOfferConfirmationCommentUpdate) => {
    return api.put<ApiOperationResult>(`/api/v1/offers/${id}/confirmation/comment`, body);
  },
  downloadOffer: async function (id: number, fileType: ApiOfferFileTypes) {
    return api.post<BlobPart>(`/api/v1/offers/${id}/download`, { file_type: fileType }, undefined, {
      responseType: "blob",
    });
  },
  getPublicOffer: async function (uuid: string, id: number) {
    return api.get<ApiOfferPublic>(`/api/v1/offers/public/${uuid}/${id}`);
  },
  updateConfig: async function (id: number, payload: ApiOfferConfig) {
    return api.put<ApiOperationResult>(`/api/v1/offers/${id}/config`, { config: payload });
  },
};
